'use strict';

class ChallengesListController {
  constructor($log,
              $scope,
              $q,
              $filter,
              $state,
              utils,
              config,
              VirtualPaginator,
              ChallengesService,
              PermissionsService) {

    // region Define fields
    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.timeFormatStr = $t('datetime.mdyHM12');
    $scope.challengeTypes = config.getConfigByKey('challengeTypes');
    $scope.challengeStatuses = config.getConfigByKey('challengeStatuses');
    $scope.searchVal = '';
    $scope.loading = false;

    let filterKey = 'Filter-Challenges-' + $scope.orgInfo.id;
    $scope.cacheFilter = false;

    // endregion

    // region Put on scope only the stuff we really need there
    angular.extend($scope, {
      //Filtering related
      toggleFilter: toggleFilter,
      isFilterDirty: isFilterDirty,
      resetFilters: resetFilters,
      filterChallenges: filterChallenges,
      initFilterFromCache: initFilterFromCache,
      closeFilter: closeFilter,

      editChallenge: editChallenge,
      deleteChallenge: deleteChallenge,
      changeStatus: changeStatus,
      refreshChallenges: refreshChallenges,

      canEditChallenge: canEditChallenge,
      canCreateChallenge: canCreateChallenge,
      canDeleteChallenge: canDeleteChallenge,
    });

    // endregion

    // Run initialization routine
    init();

    // region Methods

    function init() {

      // region Watchers
      $scope.$watchGroup(['cacheFilter', 'selectedStatusId', 'searchVal'], function() {
        // we save filter only after it was applied
        // saveFilter();
      });
      // endregion

      initFilterFromCache();

      // init pagination
      $scope.paginator = new VirtualPaginator(getChallenges);
    }

    // endregion

    // region Toggle Filter Function
    function toggleFilter() {
      $('#filter').transition('fade down');
    }

    function isFilterDirty() {
      return $scope.selectedStatusId != null;
    }

    function resetFilters() {
      closeFilter();
      $scope.selectedStatusId = null;
      $scope.filterChallenges();
    }

    /**
     * Hide filter UI
     */
    function closeFilter() {
      let visible = $('#filter').transition('is visible');
      if (visible) {
        $('#filter').transition('hide');
      }
    }

    function filterChallenges() {
      //$scope.toggleFilter();
      $scope.refreshChallenges();
    }

    function saveFilter() {
      if ($scope.cacheFilter) { //cache filter
        let params = {
          searchVal: $scope.searchVal,
          selectedStatusId: $scope.selectedStatusId
        };
        utils.setStorageItem(filterKey, params);
      } else { //remove filter
        utils.removeStorageItem(filterKey);
      }
    }

    function initFilterFromCache() {
      $scope.cacheFilter = true;
      let params = utils.getStorageItem(filterKey);
      if (params) {
        $scope.cacheFilter = true;
        $scope.selectedStatusId = params.selectedStatusId;
        $scope.searchVal = params.searchVal;
      }
    }

    function canEditChallenge() {
      return PermissionsService.canIEditChallenge();
    }

    function canCreateChallenge() {
      return PermissionsService.canICreateChallenge();
    }

    function canDeleteChallenge() {
      return PermissionsService.canIDeleteChallenge();
    }

    function editChallenge(c) {
      if (!canEditChallenge()) {
        return;
      }
      utils.setStorageItem('Selected-Challenge', c);
      let typeId = utils.getChallengeType(c);
      if (typeId === '1400') {
        $state.go('main.challenges.demand', { id: c.challengeId });
      } else if (typeId === '14001') {
        $state.go('main.challenges.weather', { id: c.challengeId });
      } else {
        $state.go('main.challenges.edit', { id: c.challengeId });
      }
    }

    function deleteChallenge(challenge) {
      if (!canDeleteChallenge()) {
        return;
      }
      $scope.loading = true;
      return ChallengesService.deleteChallenge($scope.orgInfo.id, challenge.challengeId)
        .then(function(data) {
          $scope.loading = false;
          $scope.paginator.items = $scope.paginator.items.filter(c => c.challengeId !== challenge.challengeId);
          return data;
        }, function(err) {
          $scope.loading = false;
          console.log(err);
          return $q.reject(err);
        });
    }

    function changeStatus(challenge, status) {
      if (!canEditChallenge()) {
        return;
      }
      $scope.loading = true;
      return ChallengesService
        .updateChallengeStatus($scope.orgInfo.id, challenge.challengeId, status)
        .then(data => {
          $scope.loading = false;
          challenge.status = status;
          return data;
        }, function(err) {
          $scope.loading = false;
          console.log(err);
          return $q.reject(err);
        });
    }

    function getChallenges() {
      let params = getParameters();
      $scope.loading = true;
      return ChallengesService.getChallenges($scope.orgInfo.id, params)
        .then(function(data) {
          $scope.loading = false;
          if (!data.challenges) {
            $scope.thereAreMoreItems = false;
            return;
          }
          data.challenges.forEach(function(c) {
            c.type = utils.getChallengeType(c);
            c.typeDesc = $t('challenges.types.' + c.type);
          });
          $scope.thereAreMoreItems = !!(data.collectionTotalSize && data.challenges.length < data.collectionTotalSize);
          return data.challenges;
        }, function(err) {
          $scope.loading = false;
          $scope.thereAreMoreItems = false;
          utils.handleApiError(err);
          return $q.reject(err);
        });
    }

    function getParameters() {
      let params = {
        rowCount: 300 // magic number. Check CC-433 task
      };
      if (angular.isDefined($scope.selectedStatusId) && $scope.selectedStatusId !== '' && $scope.selectedStatusId !== null) {
        params.status = $scope.selectedStatusId;
      }
      if ($scope.searchVal && $scope.searchVal !== '') {
        params.searchBy = '*' + $scope.searchVal + '*';
      }
      return params;
    }

    function refreshChallenges() {
      if ($scope.paginator) {
        saveFilter();
        $scope.paginator.reload();
      }
    }

    // endregion
  }
}

export default angular
  .module('main.challengesList.controller', [])
  .controller('ChallengesListController', ChallengesListController)
  .name;
